import BaseService from "./base"

export default class EquipmentService extends BaseService {
  resource = "/equipment"

  constructor(token, baseUrl) {
    super(token, baseUrl)
  }

  grant(id, responsible_id, person_id) {
    return this.transport.post(`${this.resource}/${id}/grant`, {responsible_id, person_id});
  }

  revoke(id, person_id) {
    return this.transport.post(`${this.resource}/${id}/revoke`, {person_id});
  }

  get_access_log(id, unity_id, options) {
    let params = {
      order_by: options.sortBy && options.sortBy[0] ? options.sortBy[0] : 'timestamp',
      sort_order: options.sortDesc && options.sortBy[0] ? 'DESC' : 'ASC',
      unity_id: options.unity_id ? options.unity_id : undefined,
      per_page: options.itemsPerPage,
      page: options.page,
    }
    params = {...params, unity_id}

    return this.transport.get(`${this.resource}/${id}/logs`, params);
  }
}
